import GoogleMapReact from "google-map-react";
import { useEffect, useRef, useState } from "react";
import { CoordAddress } from "../Map/GoogleMapAutoComplete";
import { Marker } from "./components/Marker";
import { GoogleMapAutoComplete } from "./GoogleMapAutoComplete";
import { settings } from "setting";

interface IGoogleMaps {
  center?: GoogleMapReact.Coords;
  zoom?: number;
  coords?: GoogleMapReact.Coords[];
  onPlaceSelected?: (coordAddress: CoordAddress) => void;
}

export const GoogleMaps = ({
  center = {
    lat: 10.7787887,
    lng: 106.6674621,
  },
  coords = [],
  zoom = 11,
  onPlaceSelected,
}: IGoogleMaps) => {
  const [coordSelected, setCoordSelected] = useState<CoordAddress | null>();
  const mapRef = useRef<any>(null);

  const defaultBounds = {
    north: center.lat + 0.1,
    south: center.lat - 0.1,
    east: center.lng + 0.1,
    west: center.lng - 0.1,
  };

  const handlePlaceSelect = (coordAddress: CoordAddress) => {
    setCoordSelected(coordAddress);
    onPlaceSelected?.(coordAddress);
  };

  useEffect(() => {
    if (coordSelected) {
      mapRef.current?.setCenter(coordSelected);
    }
  }, [coordSelected]);

  return (
    <div style={{ height: "300px", width: "600" }}>
      <GoogleMapAutoComplete
        defaultBounds={defaultBounds}
        onPlaceSelected={handlePlaceSelect}
      />

      <GoogleMapReact
        bootstrapURLKeys={{
          key: settings.googleMapKey as string,
          libraries: ["places"],
          language: "en",
        }}
        onGoogleApiLoaded={({ map, maps }) => {
          mapRef.current = map;
        }}
        defaultCenter={center}
        defaultZoom={zoom}
      >
        {coordSelected && (
          <Marker lat={coordSelected.lat} lng={coordSelected.lng} />
        )}
        {coords.map((e, i) => (
          <Marker key={i} lat={e.lat} lng={e.lng} />
        ))}
      </GoogleMapReact>
    </div>
  );
};
